import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { LoaderType } from '../enums/LoaderType';

@Injectable({
  providedIn: 'root'
})
export class LoaderEventsService {

  constructor() { }

  private loaderSubject: Subject<LoaderType> = new Subject();

  get loaderEvent(): Observable<LoaderType> {
    return this.loaderSubject.asObservable();
  }

  emitLoaderObject(loaderObject: LoaderType) {
    this.loaderSubject.next(loaderObject);
  }

}
